"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSubscriptionUserCapability = void 0;
var TeamSubscriptionUserCapability;
(function (TeamSubscriptionUserCapability) {
    TeamSubscriptionUserCapability["UNKNOWN"] = "unknown";
    TeamSubscriptionUserCapability["CHOOSE_PLAN"] = "choose_plan";
    TeamSubscriptionUserCapability["MANAGE"] = "manage";
    TeamSubscriptionUserCapability["CANCEL"] = "cancel";
    TeamSubscriptionUserCapability["RESUBSCRIBE"] = "resubscribe";
})(TeamSubscriptionUserCapability || (exports.TeamSubscriptionUserCapability = TeamSubscriptionUserCapability = {}));
